module.exports = __webpack_public_path__ + "img/blanket_received.30dfa069.png";